import React from "react"
import styled, { css } from "styled-components"

import ReactPlayer from "react-player"

import CloseIcon from "@images/global/close-white.svg"

const size = {
  desktop: 1440,
  tablet: 950,
  mobile: 600,
}

const below = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const ModalWrapper = styled.div`
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background-color: rgba(0, 0, 0, 0.84);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Container = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 85.5%;
  margin: 0 auto 0;
  /* padding: 0 48px; */
  z-index: 1000;
  @media (min-width: 1440px) {
    max-width: 1232px;
  }
  /* ${below.tablet`
  padding: 0 48px;
  `}
  ${below.mobile`
    padding: 0 24px;
    `} */
`
const PlayerWrapper = styled.div`
  min-width: 100%;
  position: relative;
  padding-top: 56.25%;
  z-index: 1000;
`

const CloseButton = styled.button`
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  position: absolute;

  top: -32px;
  right: 0;

  /* ${below.tablet`
  display:none;
  `} */
`

const CloseButtonItems = styled.div`
  display: flex;
  align-items: center;
  p {
    margin-right: 8px;
    margin-bottom: 0;
    color: white;
    font-size: 18px;
    line-height: 28px;
    ${below.tablet`
    font-size:15px;
    line-height:20px;
    `}
    svg {
      width: 16px;
      height: 16px;
      stroke-width: 4px;
      stroke: white;
    }
  }
  img {
    transform: translateY(1px);
  }
`

const VideoModal = props => {
  return (
    <>
      <ModalWrapper
        onClick={event => {
          event.stopPropagation()
          props.toggleModal(false)
        }}
      />
      <Container>
        <CloseButton
          onClick={event => {
            event.stopPropagation()
            props.toggleModal(false)
          }}
        >
          <CloseButtonItems>
            <p>Close</p>
            <img src={CloseIcon} alt="" />
          </CloseButtonItems>
        </CloseButton>

        <PlayerWrapper>
          <ReactPlayer
            url={`https://home.wistia.com/medias/${props.videoID}`}
            className="react-player"
            width="100%"
            height="100%"
            controls={props.controls ? true : false}
            config={{
              wistia: {
                options: {
                  doNotTrack: true,
                  fullscreenButton: true,
                },
              },
            }}
          />
        </PlayerWrapper>
      </Container>
    </>
  )
}

export default VideoModal
